// atoms/QuestionDesignTopicMenu.js

import React from 'react';

const QuestionDesignTopicMenu = ({ 
    topics, 
    selectedTopicIndex, 
    handleTopicClick, 
    handleThesisClick, 
    handleSharedQuestionsClick,
    handleQuestionTutorialClick 
}) => (
    <ul>
        {topics.map((topic) => (
            <li
                key={topic.dataID}
                onClick={() => handleTopicClick(topic.dataID)}
                className={selectedTopicIndex === parseInt(topic.dataIndex, 10) ? 'active' : ''}
            >
                {topic.dataText}
            </li>
        ))}
           {/* Add Thesis item with spacing */}
        <li
            onClick={handleThesisClick}
            className={selectedTopicIndex === 'thesisMode' ? 'active thesis-item' : 'thesis-item'}
        >
            Theses
        </li>
        {/* Add How to create questions item with same spacing */}
        <li
            onClick={handleQuestionTutorialClick}
            className={selectedTopicIndex === 'questionTutorialMode' ? 'active question-tutorial-item' : 'question-tutorial-item'}
        >
            How to create questions
        </li>
        {/* Add Shared question library item */}
        <li
            onClick={handleSharedQuestionsClick}
            className={selectedTopicIndex === 'sharedQuestionsMode' ? 'active shared-questions-item' : 'shared-questions-item'}
        >
            Shared question library
        </li>
    </ul>
);

export default QuestionDesignTopicMenu;
